import { ReactNode, SyntheticEvent } from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Tooltip from '~/components/CommonTooltip';
import useResponsive from '~/hooks/useResponsive';

import { useMoreActionsMenu } from '..';

// TODO: This was pulled as-is from DomainRow/DomainRowActionItem and can probably be made much more flexible
const MoreActionsItem = ({
  label,
  tooltipTxt = undefined,
  disabled,
  onClick = () => {},
  dataTestId,
  color = undefined,
}: {
  label: string;
  tooltipTxt?: string | ReactNode;
  disabled: boolean;
  onClick?: (e: SyntheticEvent) => void;
  dataTestId: string;
  color?: string;
}) => {
  const { handleClose } = useMoreActionsMenu();
  const { isMobile } = useResponsive();

  return (
    <Tooltip title={tooltipTxt} arrow placement={'left'}>
      {/* This div allows the Tooltip to trigger while allowing the MenuItem to be disabled */}
      <div>
        <Stack direction="row" alignItems="center">
          <MenuItem
            disabled={disabled}
            onClick={(e) => {
              // close the menu
              handleClose();
              // execute the action
              return onClick(e);
            }}
            data-testid={dataTestId}
          >
            <Typography color={color}>{label}</Typography>
          </MenuItem>
          {tooltipTxt && isMobile() && (
            <Tooltip title={tooltipTxt} arrow placement={'bottom'}>
              <IconButton size="small" sx={{ p: 0.5 }}>
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </div>
    </Tooltip>
  );
};

export default MoreActionsItem;
